import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const InfoContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.md')} ${themeGet('spacing.lg')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.75')};
`;
